import { Flex } from "antd";
import { cn } from "../../../../utils/global.utils";
import { enToBnNumber } from "../../../../utils/number.utils";
import QuizResultIcon from "../_icons/QuizResultIcon";

type Props = {
  scorePercent: number;
  correctCount: number;
  wrongCount: number;
};

export default function SubmittedQuiz({
  scorePercent,
  correctCount,
  wrongCount,
}: Props) {
  return (
    <section className="p-6 bg-white rounded-xl border border-theme-zinc-200 space-y-6">
      <Flex justify="center">
        <QuizResultIcon />
      </Flex>

      <div>
        <h6 className="text-theme-slate-700 text-3xl font-semibold text-center mb-2">
          কুইজের ফলাফল
        </h6>
        <p className="text-theme-slate-700 text-lg font-normal text-center">
          আপনার অর্জিত স্কোর
        </p>
      </div>

      <h2 className="text-center text-Base text-6xl font-medium text-theme-primary">
        {enToBnNumber(scorePercent)}%
      </h2>

      <div className="grid sm:grid-cols-2 gap-6">
        <QuizCard
          count={enToBnNumber(correctCount)}
          text="সঠিক উত্তর"
          colorClassName="text-theme-emerald-600"
        />
        <QuizCard
          count={enToBnNumber(wrongCount)}
          text="ভুল উত্তর"
          colorClassName="text-theme-red-500"
        />
      </div>
    </section>
  );
}

type IQuizCard = {
  count: string;
  text: string;
  colorClassName?: string;
};
const QuizCard = ({ count, text, colorClassName }: IQuizCard) => (
  <div className="bg-theme-slate-25 rounded-xl border border-theme-zinc-200 p-6">
    <h5 className={cn("text-center text-6xl font-medium", colorClassName)}>
      {count}
    </h5>
    <p className={cn("text-center text-lg font-medium", colorClassName)}>
      {text}
    </p>
  </div>
);
